export class EmailAccount {
  account;
  clientId;
  description;
  id;
  name;
  password;
  smtpAuth;
  smtpAuthMechanisms;
  smtpHost;
  smtpPort;
  smtpStarttlsEnable;

  constructor(obj?: EmailAccount) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/accounts/email-accounts/email-account.model.ts